// extracted by mini-css-extract-plugin
export default {"div2":"success_div2__pzjtb","videoContainer":"success_videoContainer__H11CO","button":"success_button__BCnVk"};